module.exports = __webpack_public_path__ + "fonts/DroidKufi-Bold.be72cfff.woff";